import styled from 'styled-components';
import { breakpointUp } from '../../../styles/mediaUtils';
import { typeScale } from '../../../styles/newTypography';
import { spacing } from '../../../styles/newThemeVariables.styles';
import { Authors } from '../../components/AuthorMeta/AuthorMeta.styles';
import { TagsList } from '../../blocks/TagsBlock/TagsBlock.styles';
import { Grid } from '../../layout/Grid';
import {
  ScrollableContent,
  ScrollableWrapper,
} from '../../shared/ScrollableFadeWrapper';

export const Container = styled(Grid)`
  row-gap: ${spacing.space24};

  ${ScrollableWrapper} {
    grid-column: span 2;
    grid-row: 2;

    @media ${breakpointUp.tablet} {
      grid-column: 1 / -1;
      row-gap: ${spacing.space16};
    }

    @media ${breakpointUp.desktop} {
      grid-column: span 5;
      grid-row: auto;
    }
  }

  ${ScrollableContent} {
    @media ${breakpointUp.desktop} {
      justify-content: end;
      height: 100%;
    }
  }
`;

export const Header = styled.header`
  grid-column: span 2;

  @media ${breakpointUp.tablet} {
    grid-column: span 8;
  }

  @media ${breakpointUp.desktop} {
    grid-column: span 6;
  }

  @media ${breakpointUp.desktopLarge} {
    grid-column: span 6;
  }

  &.xl {
    grid-column: span 2;

    @media ${breakpointUp.tablet} {
      grid-column: span 9;
      max-width: 41.25rem;
    }

    @media ${breakpointUp.desktop} {
      grid-column: span 10;
      max-width: 47.5rem;
    }

    @media ${breakpointUp.desktopLarge} {
      grid-column: span 7;
      max-width: 60rem;
    }
  }

  &.tags {
    @media ${breakpointUp.desktop} {
      grid-column: span 7;
    }
  }

  &.xxl {
    margin-top: 5rem;
    margin-bottom: 2rem;
    grid-column: span 2;

    @media ${breakpointUp.tablet} {
      margin-top: 10rem;
      margin-bottom: 2rem;
      grid-column: span 9;
      max-width: 47.5rem;
    }

    @media ${breakpointUp.desktop} {
      margin-top: 20rem;
      margin-bottom: 5rem;
      grid-column: span 10;
      max-width: 60.5rem;
    }

    @media ${breakpointUp.desktopLarge} {
      grid-column: span 7;
      max-width: 70rem;
    }
  }
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.textPrimary};
  text-wrap: balance;
  margin: 0;
  ${typeScale.mobile.body.xxxl};

  @media ${breakpointUp.tablet} {
    ${typeScale.tablet.body.xxxxl};
  }

  @media ${breakpointUp.desktop} {
    ${typeScale.desktop.body.xxxxl};
  }

  @media ${breakpointUp.desktopLarge} {
    ${typeScale.desktop.body.xxxxl};
  }

  .xl & {
    ${typeScale.mobile.body.xl};

    @media ${breakpointUp.tablet} {
      ${typeScale.tablet.body.xxxl};
    }

    @media ${breakpointUp.desktop} {
      ${typeScale.desktop.body.xxxxl};
    }

    @media ${breakpointUp.desktopLarge} {
      ${typeScale.desktop.body.fivexl};
    }
  }
`;

export const TagContainer = styled('div')`
  display: flex;
  align-items: end;
  justify-content: start;

  ${TagsList} {
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  @media ${breakpointUp.desktop} {
    height: 100%;
    justify-content: end;
    padding-bottom: 0;

    ${TagsList} {
      justify-content: flex-end;
    }
  }

  @media ${breakpointUp.desktopLarge} {
    grid-column: span 5;
  }
`;

export const AuthorContainer = styled('div')`
  grid-column: 1/-1;
  display: none;

  @media ${breakpointUp.desktop} {
    display: block;

    ${Authors} {
      margin-bottom: ${spacing.space48};
    }
  }
`;
